import React, {useContext, useEffect, useState } from 'react';
import "../Styles/SendReportCss.css";
import { DefaultButton, Spinner, SpinnerSize } from '@fluentui/react';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import SendReportBody from './SendReportBody';
import ModalMain from '../../../../components/Modal/ModalMain';
import { useSearchParams } from "react-router-dom";
import {ReportLinkSchema, AttachmentSchema, ReportAndAttachmentSchema} from './ReportLinkSchema';
import loaderContext from "../../../../context/loader/LoaderContext";
import { sendReportLink, sendReportAttachment,fetchReportLinkUrl ,viewSharedPdf, reSendReportLink, fetchFirmEmail, checkForSendReportField, fetchFirmNumber, sendReportLinkWhatsApp, checkWhatsAppEnabled,checkWhatsAppEnabled3} from '../../../../service/StudyListService';
import toastContext from "../../../../context/toast/ToastContext";
import { USERTYPES , TOAST_TYPE } from "../../../../constants/Constants.jsx";
import { t } from "i18next";
import userContext from '../../../../context/users/UserContext';
import { _base64ToArrayBuffer } from '../../../../service/StudyViewerService.jsx';
import { getEnv } from '../../../../helpers/EnvHelper';



export const SendReportEmail = (props) => {

    const { roles, username } = useContext(userContext);

    const [reportLink , setReportLink] = useState('');
    const [reportLinkChecked, setReportLinkChecked] = useState(false);
    const [attachmentChecked, setAttachmentChecked] = useState(false);
    const {ref, setLoaderRunning, showModal,setShowModal} = useContext(loaderContext);
    const [reportLinkEmail, setReportLinkEmail] = useState("");
    const [attachmentEmail, setAttachmentEmail] = useState("");
    const [showOnlyEmailField, setShowOnlyEmailField] = useState(false);
    const [errors, setErrors] = useState({});
    const {showToastv2} = useContext(toastContext);
    const [loadingBody,setLoadingBody] = useState(null);
    // WhatsApp shared across both sections

    const [linkWhatsappChecked, setLinkWhatsappChecked] = useState(false);
    const [linkWhatsappNumber, setLinkWhatsappNumber] = useState("");
    const [attachWhatsappChecked, setAttachWhatsappChecked] = useState(false);
    const [attachWhatsappNumber, setAttachWhatsappNumber] = useState("");
    // NEW sub-channel flags
    const [linkEmailChecked, setLinkEmailChecked] = useState(false);
    const [attachEmailChecked, setAttachEmailChecked] = useState(false);

    const [waEnabled, setWaEnabled] = useState(false);
    const [emailEnabled, setEmailEnabled] = useState(true);

    const studyId = props.studyId;
    const firmId = props.firmId;
    const clientId = props.clientId;
    const assignmentId = props.assignmentList[0].id;

    const appBaseUrl = window.location.origin + "/";
    let isEnableWhatsApp =   (getEnv("REACT_APP_ENABLE_WHATSAPP") == "true" || getEnv("REACT_APP_ENABLE_WHATSAPP") == true) ? true : false;
    const handleShareLinkCheck = async () =>{
        const new_base_url = appBaseUrl.substring(0, appBaseUrl.length - 1);
        const response = await fetchReportLinkUrl(studyId, firmId,clientId, new_base_url);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setReportLink(response.data.data.url);
        }else{
            console.log('error while fetching report link');
            // show error and close modal
        }
    }

    const handleEmailAttachmentLinkCheck = async () =>{
        let body = {
            firmId : firmId,
            clientId: clientId
        }
        const response = await fetchFirmEmail(body);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setAttachmentEmail(response.data.data);
        }else{
            console.log('error while fetching report link');
            // show error and close modal
        }
    }
   

    // keep this in SendReportEmail.jsx
    const fetchAndReturnFirmNumber = async () => {
        const body = { firmId, clientId };
        const res = await fetchFirmNumber(body);
        return (res?.status === 200 && res?.data?.result === 'SUCCESS')
            ? (res.data.data || "")
            : "";
    };

    const getReportLinkPayload = ()=>{
        let payload = {
            email : reportLinkEmail,
            reportUrl : reportLink,
            reportLinkStudyId : studyId,
            mailSelected : reportLinkChecked,
        }
        return payload;
    }

    const getAttachmentPayload = () =>{
        let data = {
            studyId : studyId,
            notificationDto : {
                clientId : clientId,
                firmId : firmId,
                studyId : studyId,
                email : attachmentEmail,
                contact : "",
                assignmentId : assignmentId
             }
        }

        return data;
    }

    useEffect(() => {
      if (!isEnableWhatsApp) {
        // Share Link
        setLinkWhatsappChecked(false);
        setLinkWhatsappNumber("");

        // Attachment
        setAttachWhatsappChecked(false);
        setAttachWhatsappNumber("");

        // Clear WhatsApp errors
        setErrors(prev => {
          const copy = { ...prev };
          delete copy.linkWhatsappNumber;
          delete copy.attachWhatsappNumber;
          return copy;
        });
      }
    }, []);

    const getLinkWhatsAppPayload = () => ({
        reportUrl: reportLink,           // you already fetched this when Share Link section is ON
        reportLinkStudyId: studyId,
        contact: linkWhatsappNumber?.trim() || "",
    });

    // Share Link → WhatsApp
    useEffect(() => {
        if (reportLinkChecked && linkWhatsappChecked && isEnableWhatsApp) {
            (async () => setLinkWhatsappNumber(await fetchAndReturnFirmNumber()))();
        } else if (!linkWhatsappChecked) {
            setLinkWhatsappNumber("");
        }
    }, [reportLinkChecked, linkWhatsappChecked]);

    // Attachment → WhatsApp
    useEffect(() => {
        if (attachmentChecked && attachWhatsappChecked && isEnableWhatsApp) {
            (async () => setAttachWhatsappNumber(await fetchAndReturnFirmNumber()))();
        } else if (!attachWhatsappChecked) {
            setAttachWhatsappNumber("");
        }
    }, [attachmentChecked, attachWhatsappChecked]);


    const getCombinedPdfPayload = () => ({
        studyId,
        notificationDto: {
            clientId, firmId, studyId,
            email:  (attachmentChecked && attachEmailChecked)   ? (attachmentEmail || "").trim()        : "",
            contact:(attachmentChecked && attachWhatsappChecked)? (attachWhatsappNumber || "").trim()   : "",
            assignmentId,
        },
    });

    const handleSendReportLink = async () =>{
        setLoaderRunning(true);
        ref.current.continuousStart();

        props.setShowSendReportModal_(false);
        let payload = getReportLinkPayload();
        const response = await sendReportLink(payload);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-success"));
            
        }else{
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.ERROR, t("send-report.error.sharing-report"));
        }
    }

    const handleSendAttachment = async ()=>{
        setLoaderRunning(true);
        ref.current.continuousStart();
        props.setShowSendReportModal_(false);

        let data = getAttachmentPayload();
        const response = await sendReportAttachment(data);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.send-report-success"));
        } else{
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.ERROR, response.data.message);
        }
    }

    const handleSendReportAndAttachment = async () =>{
        setLoaderRunning(true);
        ref.current.continuousStart();

        props.setShowSendReportModal_(false);

        let response1 = await sendReportLink(getReportLinkPayload());
        let response2 = await sendReportAttachment(getAttachmentPayload());

        if(response1.status === 200 && response2.status === 200){
            if(response1.data.result === "SUCCESS" && response2.data.result === "SUCCESS"){
                setLoaderRunning(false);
                ref.current.complete();
                showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-attachment-success"));
            }
        }else if(response1.status === 200 && response1.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-send-success"));

        }else if(response1.status === 200 && response1.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.attachment-send-success"));
        }
    }
    const onToggleShareLink = (checked) => {
        setReportLinkChecked(checked);
        if (checked) {
            setLinkEmailChecked(emailEnabled || (roles[0] == USERTYPES.ADMIN));
            //setLinkWhatsappChecked(true);
            // only auto-enable WA when firm flag allows it
            setLinkWhatsappChecked(isEnableWhatsApp && (waEnabled || (roles[0] == USERTYPES.ADMIN) ));
            handleShareLinkCheck(); // existing: fetch URL
        } else {
                            setErrors(prev => {
                const copy = { ...prev };
                delete copy.reportEmail;
                delete copy.linkWhatsappNumber;
                return copy;
                });
            setLinkEmailChecked(false);
            setLinkWhatsappChecked(false);
            setReportLinkEmail("");
            setLinkWhatsappNumber("");
        }
    };

    const onToggleAttachment = (checked) => {
        setAttachmentChecked(checked);
        if (checked) {
            setAttachEmailChecked(emailEnabled || (roles[0] == USERTYPES.ADMIN));
            //setAttachWhatsappChecked(true);
            // only auto-enable WA when firm flag allows it
            setAttachWhatsappChecked(isEnableWhatsApp && (waEnabled || (roles[0] == USERTYPES.ADMIN) ));
            handleEmailAttachmentLinkCheck(); // existing: prefill email
        } else {
                            setErrors(prev => {
                const copy = { ...prev };
                delete copy.attachmentEmail;
                delete copy.attachWhatsappNumber;
                return copy;
                });
            setAttachEmailChecked(false);
            setAttachWhatsappChecked(false);
            setAttachmentEmail("");
            setAttachWhatsappNumber("");
        }
    };


    useEffect(() => {
        if(reportLinkChecked){
            handleShareLinkCheck();
        }
    }, [reportLinkChecked]);

    useEffect(() => {
        if(attachmentChecked && (props.assignmentChain == null || props.assignmentChain == undefined)){
            handleEmailAttachmentLinkCheck();
        }else{
            setAttachmentEmail("");
        }
    }, [attachmentChecked]);

    // useEffect(() => {
    //     if (linkWhatsappChecked && reportLinkChecked) {
    //         fetchAndReturnFirmNumber().then(n => setLinkWhatsappNumber(n));
    //     }
    //     }, [linkWhatsappChecked, reportLinkChecked]);

    //     useEffect(() => {
    //     if (attachWhatsappChecked && attachmentChecked) {
    //         fetchAndReturnFirmNumber().then(n => setAttachWhatsappNumber(n));
    //     }
    // }, [attachWhatsappChecked, attachmentChecked]);

    useEffect(() => {
        if (reportLinkChecked && linkWhatsappChecked && isEnableWhatsApp) {
            fetchAndReturnFirmNumber({ firmId, clientId }).then(res =>
            setLinkWhatsappNumber(res?.data?.data || "")
            );
        } else if (!linkWhatsappChecked && !isEnableWhatsApp) {
            setLinkWhatsappNumber("");
        }
    }, [reportLinkChecked, linkWhatsappChecked]);

    useEffect(() => {
        if (attachmentChecked && attachWhatsappChecked && isEnableWhatsApp) {
            fetchAndReturnFirmNumber({ firmId, clientId }).then(res =>
            setAttachWhatsappNumber(res?.data?.data || "")
            );
        } else if (!attachWhatsappChecked && !isEnableWhatsApp) {
            setAttachWhatsappNumber("");
        }
    }, [attachmentChecked, attachWhatsappChecked]);

    // const checkForEnableAllField = async() => {
    //     setLoadingBody(true);
    //     setLoaderRunning(true);
    //     ref.current.continuousStart();

    //     const response = await checkForSendReportField({firmId:props.firmId});
    //     if(response.status === 200 && response.data.result === 'SUCCESS'){
    //         console.log("--- Value ---",response);
    //         if(response?.data?.data == false){
    //             setShowOnlyEmailField(true);
    //             setAttachmentChecked(true);
    //             handleEmailAttachmentLinkCheck();
    //         }
    //         setLoadingBody(false);
    //         setLoaderRunning(false);
    //         ref.current.complete();
    //     }else{
    //         showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
    //         setLoaderRunning(false);
    //         setLoadingBody(false);
    //         ref.current.complete();
    //     }
    // }

    // const checkForEnableAllField = async () => {
    //     console.log("--inside the checkforenalbeAllfield");
    //     setLoadingBody(true);
    //     setLoaderRunning(true);
    //     ref.current.continuousStart();

    //     try {
    //         //const resp = await checkForSendReportField({ firmId: props.firmId });
    //         // Call both endpoints in parallel
    //         const [resp, waResp] = await Promise.all([
    //           checkForSendReportField({ firmId: props.firmId }),       // existing: email vs all fields
    //           checkWhatsAppEnabled({ firmId: props.firmId })           // NEW: just WA flag
    //         ]);
    //         console.log("--resp--",resp);
    //         console.log("--waresp",waResp);

    //         if (resp.status === 200 && resp.data.result === 'SUCCESS') {
    //         const enableAll = resp?.data?.data; // legacy boolean
    //         if (enableAll === false) {
    //             setShowOnlyEmailField(true);
    //             setAttachmentChecked(true);
    //             handleEmailAttachmentLinkCheck();
    //         }
    //         }

    //         // WhatsApp flag
    //         if (waResp.status === 200 && waResp.data.result === 'SUCCESS') {
    //           const flag = !!waResp?.data?.data;
    //           console.log("whatsapp flag:",flag);
    //           // Extra client-side guard for VDC
    //           setWaEnabled(flag);
    //         } else {
    //           setWaEnabled(false);
    //         }
    //         } catch (e) {
    //             showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
    //         } finally {
    //             setLoaderRunning(false);
    //             setLoadingBody(false);
    //             ref.current.complete();
    //         }
    //     };
    // const checkForEnableAllField = async () => {
    //     console.log("--inside the checkforenalbeAllfield");
    //     setLoadingBody(true);
    //     setLoaderRunning(true);
    //     ref.current.continuousStart();

    //     try {
    //         // New single endpoint returns both flags: whatsappEnabled and emailEnabled
    //         const flagsResp = await checkWhatsAppEnabled({ firmId: props.firmId, studyId: studyId });
    //         console.log("Type of response flagsResp:", typeof flagsResp);
    //         console.log("Full response object flagsResp:", flagsResp);
    //         console.log("--flagsResp--", flagsResp?.data);

    //         if (flagsResp?.status === 200 && flagsResp?.result === 'SUCCESS') {
    //             const data = flagsResp.data.data || {};
    //             // backend returns { whatsappEnabled: bool, emailEnabled: bool }
    //             setWaEnabled(Boolean(data.whatsappEnabled));
    //             setEmailEnabled(Boolean(data.emailEnabled));
    //         } else {
    //             // fallback to false if endpoint failed
    //             setWaEnabled(false);
    //             setEmailEnabled(true); // conservative default: allow email
    //         }

    //         // Legacy/compat behavior: checkForSendReportField decides whether to show only email field
    //         const resp = await checkForSendReportField({ firmId: props.firmId});
    //         if (resp?.status === 200 && resp?.data?.result === 'SUCCESS') {
    //             const enableAll = resp.data.data;
    //             if (enableAll === false) {
    //                 setShowOnlyEmailField(true);
    //                 setAttachmentChecked(true);
    //                 handleEmailAttachmentLinkCheck();
    //             } else {
    //                 setShowOnlyEmailField(false);
    //             }
    //         }
    //     } catch (e) {
    //         showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
    //         // keep conservative defaults on error
    //         setWaEnabled(false);
    //         setEmailEnabled(true);
    //     } finally {
    //         setLoaderRunning(false);
    //         setLoadingBody(false);
    //         ref.current.complete();
    //     }
    // };
const checkForEnableAllField = async () => {
    console.log("--inside the checkforenalbeAllfield");
    setLoadingBody(true);
    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
        // --- NEW CALL: Using the simplified checkWhatsAppEnabled3 ---
        const flagsResp = await checkWhatsAppEnabled3(studyId); // Pass only studyId
        // console.log("Type of response flagsResp:", typeof flagsResp);
        // console.log("Full response object flagsResp:", flagsResp);
        // console.log("--flagsResp--", flagsResp?.data); // axios response data is the JSON body

        // **IMPORTANT:** axios responses have the JSON body in flagsResp.data
        // The result and status are directly on the response object from axios interceptor
        if (flagsResp?.status === 200 && flagsResp?.data?.result === 'SUCCESS') { 
            // Access the inner 'data' object from the server response (flagsResp.data.data)
            const data = flagsResp.data.data || {}; 
            
            // backend returns { whatsappEnabled: bool, emailEnabled: bool }
            setWaEnabled(Boolean(data.whatsappEnabled));
            setEmailEnabled(Boolean(data.emailEnabled));
        } else {
            // fallback to false if endpoint failed
            setWaEnabled(false);
            setEmailEnabled(true); // conservative default: allow email
        }

        // Legacy/compat behavior (keep this check as it's separate)
        const resp = await checkForSendReportField({ firmId: props.firmId });
        // ... (rest of the legacy logic remains the same)
        if (resp?.status === 200 && resp?.data?.result === 'SUCCESS') {
            const enableAll = resp.data.data;
            if (enableAll === false) {
                setShowOnlyEmailField(true);
                setAttachmentChecked(true);
                handleEmailAttachmentLinkCheck();
            } else {
                setShowOnlyEmailField(false);
            }
        }
    } catch (e) {
        showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
        // keep conservative defaults on error
        setWaEnabled(false);
        setEmailEnabled(true);
    } finally {
        setLoaderRunning(false);
        setLoadingBody(false);
        ref.current.complete();
    }
};
    useEffect(()=>{
        if(props.firmId != null && props.firmId != undefined){
            console.log("--- Running useEffect of send report modal ----");
            checkForEnableAllField()
        }
        
    },[])

    //  if BOTH channels are disabled → force Email ON
useEffect(() => {
  if (!emailEnabled && !waEnabled ) {
    console.log("[SendReport] Both channels disabled → forcing Email ON");

    setEmailEnabled(true);

    // also auto-enable email sub-channels if sections are active
    // if (reportLinkChecked) {
    //   setLinkEmailChecked(true);
    // }

    // if (attachmentChecked) {
    //   setAttachEmailChecked(true);
    // }
  }
}, [
  emailEnabled,
  waEnabled,
  reportLinkChecked,
  attachmentChecked
]);


    const handleClose = ()=>{
        props.setShowSendReportModal_(false);
    }

    const validateAndSubmit = (schema, values, callbackfn) =>{
        schema.validate(values, { abortEarly: false })
            .then(() => {
                callbackfn();
            })
            .catch((validationErrors) => {
              const errors = validationErrors.inner.reduce(
                (acc, error) => ({ ...acc, [error.path]: error.message }),
                {}
            );
            setErrors(errors);
        });
    }

    // const handleSubmit = () =>{
    //     console.log("--- Handle Submit ----");
    //     if(reportLinkChecked && attachmentChecked){
    //         const validationFields = {
    //             reportEmail : reportLinkEmail,
    //             attachmentEmail : attachmentEmail
    //         }
    //         validateAndSubmit(ReportAndAttachmentSchema, validationFields, handleSendReportAndAttachment);
    //     }else if(reportLinkChecked){

    //         validateAndSubmit(ReportLinkSchema, {reportEmail : reportLinkEmail}, handleSendReportLink);
    //     }else if(attachmentChecked){

    //         validateAndSubmit(AttachmentSchema, {attachmentEmail : attachmentEmail}, handleSendAttachment);
    //     }else{
    //         props.setShowSendReportModal_(false);
    //     }
    // }
    const isValidEmail = (email) => {
        if (!email) return false;
        // simple email regex (enough for UI validation)
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        };

        const isValidWhatsApp = (num) => {
        if (!num) return false;
        // require leading + and at least 8 digits (adjust to your rules)
        return /^\+\d{7,}$/.test(num);
        };

    // const handleSubmit = async () => {
    //     const tasks = [];

    //     // SHARE LINK
    //     if (reportLinkChecked) {
    //         if (linkEmailChecked) {
    //         // existing
    //         tasks.push(sendReportLink(getReportLinkPayload()));
    //         }
    //         if (linkWhatsappChecked) {
    //         tasks.push(sendReportLinkWhatsApp({
    //             reportUrl: reportLink,
    //                 reportLinkStudyId: studyId,
    //                 contact: (linkWhatsappNumber || "").trim(),
    //             }));
    //             }
    //         }

    //     // ATTACHMENT (single endpoint handles both email/contact)
    //     if (attachmentChecked) {
    //         const payload = {
    //         studyId,
    //         notificationDto: {
    //             clientId, firmId, studyId, assignmentId,
    //             email: attachEmailChecked ? (attachmentEmail || "").trim() : "",
    //             contact: attachWhatsappChecked ? (attachWhatsappNumber || "").trim() : "",
    //         }
    //     };
    //     tasks.push(sendReportAttachment(payload));
    //     }

    //     if (tasks.length === 0) {
    //         props.setShowSendReportModal_(false);
    //         return;
    //     }

    //     setLoaderRunning(true);
    //     ref.current.continuousStart();
    //     props.setShowSendReportModal_(false);

    //     const results = await Promise.allSettled(tasks);

    //     ref.current.complete();
    //     setLoaderRunning(false);

    //     const allOk = results.every(r => r.status === "fulfilled" && r.value?.status === 200 && r.value?.data?.result === "SUCCESS");
    //     showToastv2(allOk ? TOAST_TYPE.SUCCESS : TOAST_TYPE.ERROR,
    //                 allOk ? t("send-report.report-attachment-whatsapp-success") : t("send-report.error.sharing-report"));
    // };



    const handleSubmit = async () => {
    // build validation errors
    const newErrors = {};

    // SHARE LINK validations
    if (reportLinkChecked) {
    if (linkEmailChecked) {
        if (!reportLinkEmail || !(reportLinkEmail || "").trim()) {
        newErrors.reportEmail = t("string-literals.email-empty") || "Email is required";
        } else if (!isValidEmail(reportLinkEmail.trim())) {
        newErrors.reportEmail = t("string-literals.email-invalid") || "Email is invalid";
        }
    }
    if (isEnableWhatsApp && linkWhatsappChecked) {
        if (!linkWhatsappNumber || !(linkWhatsappNumber || "").trim()) {
        newErrors.linkWhatsappNumber = t("string-literals.whatsapp-number-empty") || "WhatsApp number cannot be blank";
        } else if (!isValidWhatsApp(linkWhatsappNumber.trim())) {
        newErrors.linkWhatsappNumber = t("string-literals.whatsapp-number-invalid") || "WhatsApp number invalid";
        }
    }
    }

    // ATTACHMENT validations
    if (attachmentChecked) {
    if (attachEmailChecked) {
        if (!attachmentEmail || !(attachmentEmail || "").trim()) {
        newErrors.attachmentEmail = t("string-literals.email-empty") || "Email is required";
        } else if (!isValidEmail(attachmentEmail.trim())) {
        newErrors.attachmentEmail = t("string-literals.email-invalid") || "Email is invalid";
        }
    }
    if (isEnableWhatsApp && attachWhatsappChecked) {
        if (!attachWhatsappNumber || !(attachWhatsappNumber || "").trim()) {
        newErrors.attachWhatsappNumber = t("string-literals.whatsapp-number-empty") || "WhatsApp number cannot be blank";
        } else if (!isValidWhatsApp(attachWhatsappNumber.trim())) {
        newErrors.attachWhatsappNumber = t("string-literals.whatsapp-number-invalid") || "WhatsApp number invalid";
        }
    }
    }

    // If no channels selected at all, nothing to do
    if (!reportLinkChecked && !attachmentChecked) {
        props.setShowSendReportModal_(false);
        return;
    }

    // if there are validation errors -> show them and do not proceed
    if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
    }

    // clear any old errors
    setErrors({});

    // ---------- proceed with real submit ----------
    // const tasks = [];

    // if (reportLinkChecked) {
    //     if (linkEmailChecked) {
    //     tasks.push(sendReportLink(getReportLinkPayload()));
    //     }
    //     if (linkWhatsappChecked) {
    //     tasks.push(sendReportLinkWhatsApp(getLinkWhatsAppPayload()));
    //     }
    // }

    // if (attachmentChecked) {
    //     const payload = {
    //     studyId,
    //     notificationDto: {
    //         clientId, firmId, studyId, assignmentId,
    //         email: attachEmailChecked ? (attachmentEmail || "").trim() : "",
    //         contact: attachWhatsappChecked ? (attachWhatsappNumber || "").trim() : "",
    //     }
    //     };
    //     tasks.push(sendReportAttachment(payload));
    // }

    // if (tasks.length === 0) {
    //     props.setShowSendReportModal_(false);
    //     return;
    // }

    // setLoaderRunning(true);
    // ref.current.continuousStart();

    // // do not close the modal immediately — wait for responses so UI is consistent
    // // (If you want to close modal immediately, keep existing behaviour. I recommend waiting.)
    // const results = await Promise.allSettled(tasks);

    // ref.current.complete();
    // setLoaderRunning(false);

    // const allOk = results.every(r => r.status === "fulfilled" && r.value?.status === 200 && r.value?.data?.result === "SUCCESS");
    // showToastv2(allOk ? TOAST_TYPE.SUCCESS : TOAST_TYPE.ERROR,
    //             allOk ? t("send-report.report-attachment-whatsapp-success") : t("send-report.error.sharing-report"));

    // if (allOk) {
    //     props.setShowSendReportModal_(false);
    // }
    const promiseMap = [];

  if (reportLinkChecked) {
    if (linkEmailChecked) {
      promiseMap.push({ name: "linkEmail", promise: sendReportLink(getReportLinkPayload()) });
    }
    if (linkWhatsappChecked) {
      promiseMap.push({ name: "linkWhatsApp", promise: sendReportLinkWhatsApp(getLinkWhatsAppPayload()) });
    }
  }

  if (attachmentChecked) {
    // attachment single endpoint handles email/contact together
    let email="";
    if(showOnlyEmailField)
    {
        if (isValidEmail(attachmentEmail.trim()))
            email=attachmentEmail;
        else{
            newErrors.reportEmail = t("string-literals.email-invalid") || "Email is invalid";
            setErrors(newErrors);
            return;
        }
            
    }
    else
     email=attachEmailChecked ? (attachmentEmail || "").trim() : ""
    const payload = {
      studyId,
      notificationDto: {
        clientId, firmId, studyId, assignmentId,
        email: email,
        contact: attachWhatsappChecked ? (attachWhatsappNumber || "").trim() : "",
      }
    };
    promiseMap.push({ name: "attachment", promise: sendReportAttachment(payload) });
  }

  if (promiseMap.length === 0) {
    props.setShowSendReportModal_(false);
    return;
  }

  setLoaderRunning(true);
  ref.current.continuousStart();

  // run all promises in parallel and map results back to names
  const settled = await Promise.allSettled(promiseMap.map(p => p.promise));
  ref.current.complete();
  setLoaderRunning(false);

  const mapped = settled.map((r, idx) => ({
    name: promiseMap[idx].name,
    status: r.status,
    value: r.status === "fulfilled" ? r.value : null,
    reason: r.status === "rejected" ? r.reason : null
  }));

  // find mapped entry by name
const getEntry = (name) => mapped.find(m => m.name === name) || null;

// returns true if request resolved with 200 + result === "SUCCESS"
const isSuccess = (name) => {
  const e = getEntry(name);
  return !!(e && e.status === "fulfilled" && e.value?.status === 200 && e.value?.data?.result === "SUCCESS");
};

// extract a useful error message from a mapped entry
const getErrorMessage = (name) => {
  const e = getEntry(name);
  if (!e) return null;

  // If fulfilled but backend returned FAILURE, prefer response body messages
  if (e.status === "fulfilled") {
    const body = e.value?.data;
    if (!body) return null;
    // body.message is top-level message
    if (body.message) return body.message;
    // nested channel-specific message (some endpoints return data.whatsappError)
    if (body.data && (body.data.whatsappError || body.data.error)) {
      return body.data.whatsappError || body.data.error;
    }
    // fallback to HTTP status text
    if (e.value?.statusText) return e.value.statusText;
    return null;
  }

  // If rejected, try to read axios error shape: reason.response.data...
  if (e.status === "rejected") {
    const reason = e.reason;
    if (!reason) return null;
    const resp = reason.response || reason?.response;
    if (resp?.data) {
      if (resp.data.message) return resp.data.message;
      if (resp.data.data && (resp.data.data.whatsappError || resp.data.data.error)) {
        return resp.data.data.whatsappError || resp.data.data.error;
      }
    }
    // other fallbacks
    if (reason.message) return reason.message;
    return String(reason);
  }
  return null;
};

  // helpers: check if a specific named call returned 200 + result === 'SUCCESS'
  const ok = (name) => {
    const entry = mapped.find(m => m.name === name);
    return !!(entry && entry.status === "fulfilled" && entry.value?.status === 200 && entry.value?.data?.result === "SUCCESS");
  };

  const linkEmailOk = ok("linkEmail");
  const linkWhatsAppOk = ok("linkWhatsApp");
  const attachmentOk = ok("attachment");

  // decide which toast to show using your en.json keys:
  // - both link AND attachment succeeded  -> send-report.report-attachment-success
  // - link succeeded, attachment failed  -> send-report.report-link-send-success
  // - attachment succeeded, link failed  -> send-report.attachment-send-success
  // - only link succeeded (no attachment requested) -> send-report.report-link-success
  // - only attachment succeeded (no link requested) -> send-report.send-report-success
  // - none succeeded -> show generic error

  const anyLinkOk = linkEmailOk || linkWhatsAppOk;
  const anySuccess = anyLinkOk || attachmentOk;

  // Prepare specific failure messages (if any)
    const linkEmailErrorMsg = !linkEmailOk ? getErrorMessage("linkEmail") : null;
    const linkWhatsAppErrorMsg = !linkWhatsAppOk ? getErrorMessage("linkWhatsApp") : null;
    const attachmentErrorMsg = !attachmentOk ? getErrorMessage("attachment") : null;

    // Helper to pick the best available error message or fallback to generic
    const pickError = (...candidates) => {
    for (const c of candidates) if (c) return c;
    return t("send-report.error.sharing-report"); // generic translation
    };

//   if (reportLinkChecked && attachmentChecked) {
//     if (anyLinkOk && attachmentOk) {
//       showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-attachment-success"));
//     } else if (anyLinkOk && !attachmentOk) {
//       showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-send-success"));
//     } else if (!anyLinkOk && attachmentOk) {
//       showToastv2(TOAST_TYPE.SUCCESS, t("send-report.attachment-send-success"));
//     } else {
//       showToastv2(TOAST_TYPE.ERROR, t("send-report.error.sharing-report"));
//     }
//   } else if (reportLinkChecked) {
//     if (anyLinkOk) {
//       showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-success"));
//     } else {
//       showToastv2(TOAST_TYPE.ERROR, t("send-report.error.sharing-report"));
//     }
//   } else if (attachmentChecked) {
//     if (attachmentOk) {
//       showToastv2(TOAST_TYPE.SUCCESS, t("send-report.send-report-success"));
//     } else {
//       showToastv2(TOAST_TYPE.ERROR, t("send-report.error.sharing-report"));
//     }
//   }
if (reportLinkChecked && attachmentChecked) {
  if (anyLinkOk && attachmentOk) {
    showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-attachment-success"));
  } else if (anyLinkOk && !attachmentOk) {
    // link ok, attachment failed -> show attachment error if available
    showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-send-success"));
    const msg = pickError(attachmentErrorMsg);
    if (msg) showToastv2(TOAST_TYPE.ERROR, msg, 8000);
  } else if (!anyLinkOk && attachmentOk) {
    showToastv2(TOAST_TYPE.SUCCESS, t("send-report.attachment-send-success"));
    // link failed -> show best link error
    const msg = pickError(linkWhatsAppErrorMsg, linkEmailErrorMsg);
    if (msg) showToastv2(TOAST_TYPE.ERROR, msg, 8000);
  } else {
    // both failed -> show best single useful error (prefer WhatsApp link error)
    const msg = pickError(linkWhatsAppErrorMsg, linkEmailErrorMsg, attachmentErrorMsg);
    showToastv2(TOAST_TYPE.ERROR, msg, 8000);
  }
} else if (reportLinkChecked) {
  if (anyLinkOk) {
    // Check if both channels were attempted
    const bothChannelsAttempted = linkEmailChecked && linkWhatsappChecked;
    const bothSucceeded = linkEmailOk && linkWhatsAppOk;
    
    if (bothChannelsAttempted && !bothSucceeded) {
      // Partial success - show which one succeeded
      if (linkEmailOk && !linkWhatsAppOk) {
        showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-success") + " (Email)");
        const msg = pickError(linkWhatsAppErrorMsg);
        if (msg) showToastv2(TOAST_TYPE.ERROR, "WhatsApp: " + msg, 8000);
      } else if (!linkEmailOk && linkWhatsAppOk) {
        showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-success") + " (WhatsApp)");
        const msg = pickError(linkEmailErrorMsg);
        if (msg) showToastv2(TOAST_TYPE.ERROR, "Email: " + msg, 8000);
      }
    } else {
      // All attempted channels succeeded
      showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-success"));
    }
  } else {
    // no link succeeded -> show best link error
    const msg = pickError(linkWhatsAppErrorMsg, linkEmailErrorMsg);
    showToastv2(TOAST_TYPE.ERROR, msg, 8000);
  }
} else if (attachmentChecked) {
  if (attachmentOk) {
    showToastv2(TOAST_TYPE.SUCCESS, t("send-report.send-report-success"));
  } else {
    const msg = pickError(attachmentErrorMsg);
    showToastv2(TOAST_TYPE.ERROR, msg, 8000);
  }
}

  // close modal if anything succeeded (optional — keep or remove)
  if (anySuccess) {
    props.setShowSendReportModal_(false);
  }
};

    let PrimaryButtonList = [
        {
            title:"Send",
            onclick: handleSubmit,
        }
    ];
    let DefaultButtonList = [
        {
            title:"Cancel",
            onclick: handleClose
        }
    ];

    const spinnerStyle = {
        circle: {
          height: "30px",
          width: "30px",
          borderWidth: "5px",
        }
      }

    const modalDetails = {
        header: <ModalHeader updatedModal={true} showPatientDetails={false} heading={t("heading.send-report")} handleCancel={handleClose}/>,
        footer : <ModalFooter DefaultButtonList={DefaultButtonList} PrimaryButtonList={PrimaryButtonList}/>,
        body : (loadingBody != null && !loadingBody) ?<SendReportBody showOnlyEmailField={showOnlyEmailField} handleShareLinkCheck = {handleShareLinkCheck} handleEmailAttachmentLinkCheck={handleEmailAttachmentLinkCheck}  reportLink = {reportLink} 
                // setAttachmentChecked = {setAttachmentChecked}
                // setReportLinkChecked = {setReportLinkChecked} 
                setAttachmentChecked={onToggleAttachment}
                setReportLinkChecked={onToggleShareLink}
                reportLinkChecked = {reportLinkChecked} 
                attachmentChecked = {attachmentChecked}

                attachmentEmail = {attachmentEmail} 
                setReportLink={setReportLink} 
                reportLinkEmail={reportLinkEmail} 
                setReportLinkEmail = {setReportLinkEmail} 
                setAttachmentEmail = {setAttachmentEmail} 
                // linkEmailChecked={linkEmailChecked} 
                // setLinkEmailChecked={setLinkEmailChecked} 
                linkEmailChecked={linkEmailChecked}
                setLinkEmailChecked={setLinkEmailChecked}
                // attachmentEmailChecked={attachmentEmailChecked} 
                // setAttachmentEmailChecked={setAttachmentEmailChecked}
                attachmentEmailChecked={attachEmailChecked}
                setAttachmentEmailChecked={setAttachEmailChecked}
                linkWhatsappChecked={linkWhatsappChecked}
                setLinkWhatsappChecked={setLinkWhatsappChecked}
                linkWhatsappNumber={linkWhatsappNumber}
                setLinkWhatsappNumber={setLinkWhatsappNumber}
                attachWhatsappChecked={attachWhatsappChecked}
                setAttachWhatsappChecked={setAttachWhatsappChecked}
                attachWhatsappNumber={attachWhatsappNumber}
                setAttachWhatsappNumber={setAttachWhatsappNumber}
                whatsappEnabled={waEnabled}
                emailEnabled={emailEnabled}
                errors = {errors}
                setErrors={setErrors}/>:
                <>
                <div style={{padding:'30px 30px'}}><Spinner size={SpinnerSize.large} styles={spinnerStyle}/></div>
                </>,
        width : "500px",
        maxHeight: "75vh",
      }

  return (
    <>
        <ModalMain updatedModal={true} showModal={true} modalDetails={modalDetails} scrollableBody={true} />
    </>
  )
}


export const SharedReport = ()=>{
    const [searchParams] = useSearchParams();
    const [pdfUrl, setPdfUrl] = useState("");
    const [expiredLink, setExpiredLink] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const [disableResendButton, setDisableResendButton] = useState(false);
    const {ref, setLoaderRunning, showModal,setShowModal} = useContext(loaderContext);
    const {showToastv2} = useContext(toastContext);
    const [error, setError] = useState(null);
    const [genericErrorMessage, setGenericErrorMessage] = useState("");

    useEffect(() => {
        document.title = "View Report";
      }, []);

    useEffect(() => {
       
        async function fetchPdf () {
            setLoaderRunning(true);
            ref.current.continuousStart();
    

            let encrypted_id = searchParams.get("q");

           try{ const response = await viewSharedPdf(encrypted_id);
            if(response.status === 200){
                if (response.data.result && response.data.result === "FAILURE") {
                        if (response.data.message === "REPORT_LINK_EXPIRED") {
                            setExpiredLink(true);
                            setUserEmail(response.data.data);
                            setError("EXPIRED");
                        } else if (response.data.message === "REPORT_NOT_READY") {
                            setError("NOT_READY");
                        } else {
                            setError("GENERIC");
                            setGenericErrorMessage(response.data.message);
                        }

                        setLoaderRunning(false);
                        ref.current.complete();
                        return;
                }
                
                console.log('pdf response loaded successfully!!',response);
                const fileData = _base64ToArrayBuffer(response?.data?.data?.data);
                const pdfBlob = new Blob([fileData], { type: 'application/pdf' });
                const c_pdfUrl = URL.createObjectURL(pdfBlob);
                setPdfUrl(c_pdfUrl);
                setLoaderRunning(false);
                ref.current.complete();          
            } else {
                setError("GENERIC");
                setLoaderRunning(false);
                ref.current.complete();
            }
        }catch(e){
            console.log("--- Error ---",e);
            setError("GENERIC");
            setGenericErrorMessage(e?.response?.data?.message || "Failed to load report. Please try again.");
            setLoaderRunning(false);
            ref.current.complete();
            }
        }
        fetchPdf();
      }, []);

      const handleResendLink = async () =>{

        setLoaderRunning(true);
        ref.current.continuousStart();

        let encrypted_id = searchParams.get("q");
        const appBaseUrl = window.location.origin + "/";
        const payload = {
            encryptedLink : encrypted_id, 
            baseUrl : appBaseUrl.substring(0, appBaseUrl.length - 1)
        }

        const response = await reSendReportLink(payload);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-reshared"));
            setDisableResendButton(true);
        }else{
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.ERROR, t("send-report.error.resharing-report"));
        }
      }

      return (
        <div style={{height : "100%",display:'flex',alignItems:'center',justifyContent:'center'}}>
          {expiredLink ? (
            <div>
                <p style={{ textAlign: "center" }}>{t("send-report.report-link-expired")}</p>
                {userEmail ? (
                        <p style={{ textAlign: "center" }}>{t("send-report.new-link")}
                            <DefaultButton
                                text={t("button.click")}
                                disabled={disableResendButton}
                                onClick={handleResendLink}
                            />
                        </p>
                        ) : (
                        <p style={{ textAlign: "center" }}>
                            {t("send-report.contact-support-new-url")}
                        </p>
                )}
            </div>
            ) : error === "NOT_READY" ? (
                <p style={{ textAlign: "center" }}>Report is not yet ready. Please try again after some time.</p>
            ) : error === "GENERIC" ? (
                 <p style={{ textAlign: "center" }}>{genericErrorMessage || t("string-literals.error-msg")}</p>
            ) : pdfUrl ? (
                <embed src={pdfUrl} type="application/pdf" width="100%" height="99%" />
            ) : (
                <p style={{ textAlign: "center" }}>{t("send-report.loading-pdf")}</p>
            )
         }
        </div>
    );

}